import {NotificationService} from "@vues/v-common";
import {InvoiceController} from "@/invoice-transmission/controllers/invoice_transmission/InvoiceController";
import {ProofController} from "@/purchase/controllers/ProofController";

// Enregistre un fichier reçu du serveur sur l'ordinateur de l'utilisateur
function saveFile(file, fileName) {
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
}

// Une erreur du serveur arrive en JSON, pas en fichier
const isFile = file => file instanceof Blob && !file.type.includes("json");

/**
 * Télécharge le fichier de la facture reçue (PDF ou XML selon ce que le fournisseur a déposé sur la plateforme)
 * d'un achat issu d'une facture reçue.
 */
export async function downloadIncomingInvoice(purchase) {
    const providerInvoiceId = purchase?.incomingInvoice?.providerInvoiceId;
    if (!providerInvoiceId) {
        (new NotificationService).addNotification("danger", "Cet achat n'est pas lié à une facture reçue.");
        return;
    }

    const file = await InvoiceController.download(providerInvoiceId);

    if (!isFile(file)) {
        (new NotificationService).addNotification("danger", "Impossible de télécharger la facture.");
        return;
    }

    const extension = file.type.includes("pdf") ? "pdf" : "xml";
    const number = purchase.incomingInvoice.number ?? purchase.reference ?? '';
    const supplier = purchase.supplierName ? "_" + purchase.supplierName.replaceAll(' ', '_').replace(/[<>:|?*\\/]/g, '') : '';
    saveFile(file, `Facture_${number}${supplier}.${extension}`);
}

/**
 * Télécharge un justificatif téléversé sur un achat.
 */
export async function downloadProof(purchaseId, proof) {
    const file = await ProofController.download(purchaseId, proof.id);
    if (!isFile(file)) {
        (new NotificationService).addNotification("danger", "Impossible de télécharger le justificatif.");
        return;
    }
    saveFile(file, proof.name);
}
